import Detailed from './detailed';
export default Detailed;
